import React, { useEffect, useState } from 'react';
import { Redirect } from 'react-router-dom';
import Card from 'react-bootstrap/Card';
import Nav from 'react-bootstrap/Nav';
import Toast from 'react-bootstrap/Toast';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import { ProgressBar, Spinner } from 'react-bootstrap';
import ExcelJS from 'exceljs';
import { TruperTableAPI } from 'truper-web-react-components';
import FormularioService from '../API/FormularioService';
import logo_tescucha from '../images/logo_tescucha.png';
import '../styles/Bandeja.css';
import { useAppDispatch, useAppSelector } from '../hooks/reduxHooks';
import { removeFoilData } from '../redux/foil/foilSlice';
import BandejaSearch from '../components/organisms/BandejaSearch';
import { setEstatus, setTipoDenunciaMejora } from '../redux/catalog/catalogSlice';
import { logout } from '../redux/admin/adminSlice';
import localStorageConstants, { getFromLocalStorage } from '../constants/localstorage';
import CatalogoService from '../API/CatalogoService';

const Loader = () => (
  <div
    className="text-white d-flex flex-column justify-content-center align-items-center"
    style={{ height: '100%', width: '100%' }}
  >
    <Spinner animation="border" variant="warning" />
    <h2 className="color">Preparando el archivo...</h2>
  </div>
);

const columns = [
  { Header: 'Folio', accessor: 'folio' },
  { Header: 'Tipo', accessor: 'tipo' },
  { Header: 'Subtipo', accessor: 'tipoDenunciaMejora' },
  { Header: 'Situacion', accessor: 'txtSituacion', disableSort: true },
  { Header: 'Estatus', accessor: 'estatus' },
  { Header: 'Fecha', accessor: 'fecha' },
  { Header: 'Dias', accessor: 'dias', disableSort: true },
];

const Bandeja = ({ match }) => {
  const [loading, setLoading] = useState(false);
  const dispatch = useAppDispatch();
  const { isLogged } = useAppSelector(({ adminReducer }) => adminReducer);
  const [state, setState] = useState({
    showToast: false,
    mensajeToast: '',
    loadPercentage: 0,
  });
  const [isLoading, setIsLoading] = useState(false);
  const [dataFilters, setDataFilters] = useState({
    folio: null,
    estatusDenuncia: null,
    tipoSugerencia: null,
    tipoDenunciaMejora: null,
    tipoConducta: null,
  });
  const [totalResults, setTotalResults] = useState(null);
  const [denunciasForFiles, setDenunciasForFiles] = useState([]);
  const [progress, setProgress] = useState(0);

  const styles = useStyles(state.showToast);
  const isFixTescucha = window.location.pathname.includes('fix-tescucha');

  const consultarFolio = folio => {
    const contextPath = isFixTescucha ? 'fix-tescucha' : 'tescucha';
    window.open(
      `/${contextPath}/viewForm/${match.params.perfil}/2?folio=${folio}&clave=&noSyncCatalogs=true`,
      '_blank'
    );
  };

  const getCatalogs = async () => {
    try {
      const [respTipoDenunciaMejora, respEstatus] = await Promise.all([
        CatalogoService.consultaCatalogo({ dispatch, path: 'tipo-comportamiento' }),
        CatalogoService.consultaCatalogo({ dispatch, path: 'estatus' }),
      ]);

      setEstatus(dispatch, respEstatus);
      setTipoDenunciaMejora(dispatch, respTipoDenunciaMejora);
    } catch (error) {
      console.error('Error loading catalogs:', error);
    }
  };

  const getDataForFiles = async () => {
    return FormularioService.consultaDenuncias({ dispatch, dataFilters }).then(results => {
      setDenunciasForFiles(results?.data || []);
    });
  };

  const generateExcelFile = async data => {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Denuncias');

    worksheet.columns = [
      { header: 'Folio', key: 'folio', width: 15 },
      { header: 'Tipo', key: 'tipo', width: 20 },
      { header: 'Subtipo', key: 'tipoDenunciaMejora', width: 20 },
      { header: 'Situación', key: 'txtSituacion', width: 25 },
      { header: 'Estatus', key: 'estatus', width: 15 },
      { header: 'Fecha', key: 'fecha', width: 15 },
      { header: 'Días', key: 'dias', width: 10 },
    ];

    // Estilos para encabezados
    const headerRow = worksheet.getRow(1);
    headerRow.font = { bold: true, size: 12 };
    headerRow.fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: 'FFE0E0E0' },
    };
    headerRow.alignment = { vertical: 'middle', horizontal: 'center' };

    // Agregar datos
    worksheet.addRows(data);

    // Dar formato a las celdas de datos
    worksheet.eachRow({ includeEmpty: false }, (row, rowNumber) => {
      if (rowNumber > 1) {
        row.alignment = { vertical: 'middle', horizontal: 'left' };
        row.font = { size: 11 };
      }
    });

    // Agregar bordes a todas las celdas
    worksheet.eachRow(row => {
      row.eachCell(cell => {
        cell.border = {
          top: { style: 'thin' },
          left: { style: 'thin' },
          bottom: { style: 'thin' },
          right: { style: 'thin' },
        };
      });
    });

    return workbook.xlsx.writeBuffer();
  };

  const downloadExcel = async () => {
    setLoading(true);
    try {
      // Primer intento: descarga desde el servidor
      const response = await fetch('/context/tescucha/api/v1/admin/legacy/denuncias/report', {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${getFromLocalStorage(localStorageConstants.token)}`,
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        throw new Error('Fallo la descarga del servidor');
      }

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'TEscucha línea de denuncia.xlsx');
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Error en descarga desde servidor:', error);

      try {
        // Plan B: Generar excel en el cliente
        await getDataForFiles(); // Actualizar datos si es necesario
        const buffer = await generateExcelFile(denunciasForFiles);

        const blob = new Blob([buffer], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = 'TEscucha línea de denuncia.xlsx';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      } catch (clientError) {
        console.error('Error generando Excel en cliente:', clientError);
        setState(prevState => ({
          ...prevState,
          showToast: true,
          mensajeToast: 'Error al generar el archivo Excel',
        }));
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    removeFoilData(dispatch);
    getCatalogs();
  }, []);

  useEffect(() => {
    if (progress >= 100) {
      setTimeout(() => {
        setProgress(0);
      }, 30);
    }

    const timer = setInterval(() => {
      setProgress(prevProgress => prevProgress + 1);
    }, 30);

    if (!isLoading) {
      setProgress(0);
      clearInterval(timer);
    }

    return () => clearInterval(timer);
  }, [progress, isLoading]);

  if (!isLogged) {
    return <Redirect to="/acceso/login" />;
  }

  return (
    <div className="container-bandeja">
      <Toast
        onClose={() => setState(prevState => ({ ...prevState, showToast: false }))}
        show={state.showToast}
        delay={3000}
        autohide
        style={styles.Toast}
      >
        <Toast.Header>
          <img src={logo_tescucha} className="rounded mr-2" alt="" />
          <strong className="mr-auto">TEscucha</strong>
          <small>Consulta de sugerencia</small>
        </Toast.Header>
        <Toast.Body>{state.mensajeToast}</Toast.Body>
      </Toast>

      <BandejaSearch setDataFilters={obj => setDataFilters(obj)} />

      <Container className="mb-2">
        <Row xs="auto">
          <Col style={{ display: 'flex', justifyContent: 'flex-end' }}>
            <Button onClick={downloadExcel} variant="outline-success" disabled={loading}>
              {loading ? <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" /> : 'xls'}
            </Button>
          </Col>
        </Row>
        {loading && (
          <div
            style={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100vh',
              backgroundColor: '#38383873',
              zIndex: 99,
              display: 'flex',
              alignItems: 'center',
              flexFlow: 'columns',
            }}
          >
            <Loader />
          </div>
        )}
      </Container>

      <Container>
        <Card>
          <Card.Header>
            <Nav variant="tabs" defaultActiveKey="#pendientes">
              <Nav.Item>
                <Nav.Link href="#pendientes">
                  <strong className="enfasis">{totalResults || '0'}</strong>&nbsp;Resultados
                </Nav.Link>
              </Nav.Item>
            </Nav>
          </Card.Header>
          <Card.Body>
            <div className="TruperTableContainer">
              {isLoading && (
                <div className="progressBar-contenedor-carga">
                  <h4>Cargando las denuncias</h4>
                  <ProgressBar animated now={progress} style={{ marginTop: '20px' }} />
                </div>
              )}

              <TruperTableAPI
                columnsProperty={columns}
                dynamicHeight={false}
                rowsDisplayed={15}
                onRowDoubleClick={row => consultarFolio(row.values.folio, row.original?.clave)}
                firstLastPage
                disableMultiSort
                disableComputedSort
                onLoading={value => setIsLoading(value)}
                onRequestError={e => {
                  if (String(e?.status) === '401') {
                    logout(dispatch);
                    window.open(process.env.REACT_APP_ssoUrl, '_self');
                  }
                }}
                onRequestResponse={res => {
                  setTotalResults(res?.totalCount || 0);
                }}
                API={{
                  url: '/context/tescucha/api/v1/admin/legacy/denuncias',
                  headers: {
                    Authorization: `Bearer ${getFromLocalStorage(localStorageConstants.token)}`,
                  },
                  method: 'POST',
                  queryParams: {
                    page: 1,
                    rows: 15,
                  },
                  data: dataFilters,
                }}
              />
            </div>
          </Card.Body>
        </Card>
      </Container>
    </div>
  );
};

const useStyles = showToast => ({
  Toast: {
    position: 'fixed',
    top: 60,
    right: 10,
    zIndex: showToast ? 100 : 0,
  },
});

export default Bandeja;
